// src/components/Footer.jsx
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import { useState } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [email, setEmail] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    setEmail("");
    alert("¡Gracias! Te avisamos cuando haya novedades ✌️");
  };

  return (
    <footer className="mt-16 border-t border-black/10 bg-white text-black">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        {/* Links principales */}
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-8 md:gap-12">
          {/* Columna 1 - Conectá */}
          <div>
            <h3 className="text-sm font-semibold mb-3 tracking-wide">Nosotros</h3>
            <div className="flex items-center gap-4">
              {/* Instagram */}
              <a
                href="https://www.instagram.com/wetsoul.ar/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-2xl hover:text-pink-600 transition"
              >
                <FaInstagram />
              </a>

              {/* WhatsApp */}
              <a
                href="https://wa.me/5492215444828?text=Hola!%20Quiero%20saber%20m%C3%A1s%20sobre%20las%20mallas"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="text-2xl hover:text-green-600 transition"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>

          {/* Columna 2 - Ayuda */}
          <div>
            <h3 className="text-sm font-semibold mb-3 tracking-wide">Ayuda</h3>
            <ul className="space-y-2">
              <li><Link to="/contacto" className="hover:underline">Envíos</Link></li>
              <li><Link to="/contacto" className="hover:underline">Pagos</Link></li>
              <li><Link to="/devolucion" className="hover:underline">Política de Devolución</Link></li>
            </ul>
          </div>

          {/* Columna 3 - Newsletter */}
          <div>
            <h3 className="text-sm font-semibold mb-3 tracking-wide">Conectá con WetSoul</h3>
            <p className="text-sm mb-3">
              Sumate para enterarte de lanzamientos y promos. 
            </p>
            <form onSubmit={onSubmit} className="flex items-center gap-2">
              <label htmlFor="footer-email" className="sr-only">Email</label>
              <input
                id="footer-email"
                type="email"
                required
                placeholder="tu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-lg border border-black/20 bg-white px-3 py-2 outline-none focus:border-black"
              />
              <button
                type="submit"
                className="rounded-lg border border-black px-4 py-2 text-sm font-medium hover:bg-black hover:text-white transition"
              >
                Enviar
              </button>
            </form>

            {/* Selector de moneda/país */}
            <div className="mt-4">
              <label htmlFor="currency" className="text-xs block mb-1">Moneda</label>
              <select
                id="currency"
                className="rounded-lg border border-black/20 bg-white px-3 py-2 text-sm"
                defaultValue="ARS"
              >
                <option value="ARS">ARS $</option>
              </select>
            </div>
          </div>

          {/* Columna 4 - Legal */}
          <div>
            <h3 className="text-sm font-semibold mb-3 tracking-wide">Legal</h3>
            <ul className="space-y-2">
              <li><Link to="/privacidad" className="hover:underline">Política de Privacidad</Link></li>
            </ul>
          </div>
        </div>

        {/* Línea divisoria */}
        <div className="my-8 border-t border-black/10" />

        {/* Legal base */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-sm">
          <p>© {new Date().getFullYear()} WetSoul — trademarked & all rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}